import { FC } from 'react';
import { RecognitionsLayout } from 'pages/atoms';
import { RecognitionsAchievementsLists } from 'containers/recognitions';

const RecognitionsAchievementsPage: FC = () => {
  return (
    <RecognitionsLayout>
      <RecognitionsAchievementsLists />
    </RecognitionsLayout>
  );
};

export default RecognitionsAchievementsPage;
